const state = {
  list: [],
  selectedDomain: null,
};

const getters = {
  globalDomainList: (state) => state.list,
  selectedGlobalDomain: (state) => state.selectedDomain,
};

const actions = {
  async fetchGlobalDomainListEntry({ commit }, { action, domainId }) {
    const response = await this._vm.$http.get(`/restapi/${action}/${domainId}`);

    commit("setSelectedListEntry", response.data);
  },

  async fetchGlobalDomainList({ commit }) {
    const response = await this._vm.$http.get(`/restapi/all`);

    commit("setGlobalList", response.data.data);
  },
  // eslint-disable-next-line no-unused-vars
  async importGlobalDomains({ _ }, { file, action }) {
    let csv = new FormData();

    csv.append("csv", file);

    await this._vm.$http.post(`/restapi/import/${action}?overwrite=true`, csv, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async createGlobalDomainListEntry({ commit }, { action, body }) {
    const response = await this._vm.$http.post(`/restapi/${action}`, body);

    commit("addListEntry", response.data);
    return response.data;
  },

  async updateGlobalDomainListEntry({ commit }, { domainId, action, body }) {
    const response = await this._vm.$http.post(
      `/restapi/${action}/${domainId}`,
      body
    );

    const index = state.list.findIndex(
      (entry) => entry.id === response.data.id
    );

    if (index === -1) {
      commit("addListEntry", response.data);
    } else {
      commit("updateListEntry", {
        idx: index,
        locationAddress: response.data,
      });
    }

    commit("setSelectedListEntry", response.data);
  },

  async deleteGlobalDomainListEntrys({ commit }, { domains }) {
    const req = {};

    for (const domain of domains) {
      req[`${domain.id}`] = {
        method: "delete",
        path: `/${domain.object}/${domain.id}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteListEntry", ids);
  },
};

const mutations = {
  setGlobalList: (state, data) => (state.list = data),
  setSelectedListEntry: (state, data) => (state.selectedDomain = data),
  addDomainListEntry: (state, data) => state.list.push(data),
  addListEntry: (state, data) => state.list.push(data),
  updateListEntry: (state, data) =>
    (state.list[`${data.idx}`] = data.locationAddress),
  deleteListEntry(state, domains) {
    state.list = state.list.filter((domain) => !domains.includes(domain.id));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
